import React, { useEffect, useState } from "react";
import { Input, Button } from "antd";

export const DomainNameInput = ({
  mode = "normal",
  oldValue = "",
  value,
  loading = false,
  onChange,
  onCheckDuplicated,
  placeholder = "Enter domain name",
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    const disabled =
      mode === "update" && (oldValue === inputValue || inputValue === "");
    setButtonDisabled(disabled);
  }, [inputValue, oldValue, mode]);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Input
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={placeholder}
        style={{ width: "400px", marginRight: "10px" }}
      />
      <Button
        onClick={() => onCheckDuplicated(inputValue)}
        disabled={isButtonDisabled}
        loading={loading}
      >
        Validate
      </Button>
    </div>
  );
};
